import React from 'react'
import get from 'lodash/get'
import { BTitle, BLink } from '@prague-digi/ui-components'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { Response } from '../../../../api/api'
import routes from '../../../../constants/routes'
import { modalDialogActions } from '../../../../redux'
import {
  API_ERROR,
  CLIENT_INFO_ENCRYPTION,
  CLIENT_INFO_MARKETING,
  CLIENT_INFO_IM,
  EXIT_14_DAYS,
  ID_CARD_NUMBER_HINT,
  ID_CARD_VALIDITY_HINT,
  INSURANCE_QUESTION,
  LOAN_DATA_MISSING,
  MAKE_CACHE_AUTH_DIALOG,
  ONLINE_VERIFICATION,
  OTHER_COST_OF_LIVING_MODAL,
  PERSONAL_NUMBER_HINT,
  POP_FILES_COUNT,
  POP_UPLOAD_FAILED,
  POP_WRONG_FILE,
  RESET_CONTINUE_DIALOG,
  SHOW_INACTIVITY_LOGOUT,
  SHOW_INACTIVITY,
  SHOW_NEEDED_DOCS,
  SMS_VERIFY,
} from '../../../../constants/modals'

interface Props {
  hideAllModalDialogs: any
  push: any
  showModalDialog: any
}

export const RouteHelper = ({ push, hideAllModalDialogs, showModalDialog }: Props) => {
  const list: any[] = []

  const goto = (key: string) => {
    hideAllModalDialogs()
    push(get(routes, key))
  }

  const modals = [
    ...[Response.networkError, Response.serverErrorRetry, Response.serverErrorStop].map(
      (api: Response) => ({
        ...API_ERROR({ errorInfo: { type: api }, onRetry: hideAllModalDialogs }),
        id: `API_ERROR_${api}`,
      })
    ),

    CLIENT_INFO_ENCRYPTION,
    CLIENT_INFO_MARKETING,
    CLIENT_INFO_IM,
    EXIT_14_DAYS(hideAllModalDialogs, hideAllModalDialogs, 123456),
    ID_CARD_NUMBER_HINT,
    ID_CARD_VALIDITY_HINT,
    INSURANCE_QUESTION(hideAllModalDialogs, hideAllModalDialogs, 123456),
    LOAN_DATA_MISSING,
    MAKE_CACHE_AUTH_DIALOG('1234'),
    ONLINE_VERIFICATION,
    OTHER_COST_OF_LIVING_MODAL({ amount: '123 Kč', callback: hideAllModalDialogs }),
    PERSONAL_NUMBER_HINT,
    POP_FILES_COUNT(hideAllModalDialogs),
    POP_UPLOAD_FAILED(hideAllModalDialogs),
    POP_WRONG_FILE,
    RESET_CONTINUE_DIALOG,
    SHOW_INACTIVITY_LOGOUT,
    SHOW_INACTIVITY,
    SHOW_NEEDED_DOCS,
    SMS_VERIFY,
  ]

  Object.keys(routes).forEach((key: string) => {
    list.push(
      <li key={key}>
        <BLink onClick={() => goto(key)}>
          {key} {get(routes, key)}
        </BLink>
      </li>
    )
  })

  return (
    <div>
      <BTitle type="h4">Pages</BTitle>
      <ul>{list}</ul>
      <div>
        <BTitle type="h4">Modals</BTitle>
        <ul>
          {modals.map(modal => (
            <li key={modal.id}>
              <BLink onClick={() => showModalDialog(modal)}>{modal.id}</BLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default connect(null, {
  hideAllModalDialogs: modalDialogActions.hideAllModalDialogs,
  showModalDialog: modalDialogActions.showModalDialog,
  push,
})(RouteHelper)
